import React, { Component } from 'react';
import { string, arrayOf } from 'prop-types';
import { Message } from 'semantic-ui-react';

import Feed from '../components/Feed';
import getPlaylists from '../components/getPlaylists';

const initialState = { items: [], loading: true };

class Playlists extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
  }

  componentDidMount() {
    const { blacklist, channel, ytKey } = this.props;
    getPlaylists(blacklist, channel, ytKey)
      .then(res => this.setState({ loading: false, items: res }))
      .catch(() => this.setState({ loading: false, err: 'API Fetch Error' }));
  }

  render() {
    const { items, loading, err } = this.state;
    return (
      <div>
        {!err ? (
          <Feed items={items} loading={loading} />
        ) : (
          <Message negative header="Error" content={err} />
        )}
      </div>
    );
  }
}

Playlists.propTypes = {
  blacklist: arrayOf(string),
  channel: string.isRequired,
  ytKey: string.isRequired,
};

Playlists.defaultProps = {
  blacklist: [],
};

export default Playlists;



// WEBPACK FOOTER //
// ./src/Routes/Playlists.jsx